module.exports = __webpack_public_path__ + "static/Sawal_Front_Big-70cbe958ed169bad92abf9edefd7c4fb.png";